import { Button } from "@/components/ui/button";
import { Download, Info, Loader2 } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useState } from "react";
import { useImpactPdfExportJadlog } from "@/hooks/useImpactPdfExportJadlog";
import type {
  ImpactFiltersJadlog,
  ImpactKPIJadlog,
  MaterialSummaryJadlog,
  UnitRankingJadlog,
} from "@/hooks/useImpactDataJadlog";
import { toast } from "sonner";

interface ImpactHeaderJadlogProps {
  filters: ImpactFiltersJadlog;
  data: {
    totalWeight: number;
    materialSummary: MaterialSummaryJadlog[];
    kpis: ImpactKPIJadlog[];
    unitRanking: UnitRankingJadlog[];
  };
}

export const ImpactHeaderJadlog = ({
  filters,
  data,
}: ImpactHeaderJadlogProps) => {
  const [isExporting, setIsExporting] = useState(false);
  const { exportToPdf } = useImpactPdfExportJadlog();

  const handleExport = async () => {
    if (data.kpis.length === 0) {
      toast.error("Não há dados para exportar");
      return;
    }

    setIsExporting(true);
    try {
      exportToPdf({ filters, data });
      toast.success("PDF exportado com sucesso!");
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast.error("Erro ao exportar PDF");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex items-start justify-between mb-6 md:mb-8">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-2xl md:text-3xl font-bold text-[#10261F] ">
            Dados de Impacto
          </h1>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="h-5 w-5 text-gray-500 cursor-help" />
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">
                <p>
                  Dados calculados com base nas fórmulas de impacto ambiental
                  por tipo de material.
                </p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <p className="text-gray-600 mt-2  text-sm md:text-base">
          Acompanhe o impacto positivo da sua empresa no meio ambiente
        </p>
      </div>
      <Button
        variant="outline"
        className="gap-2"
        onClick={handleExport}
        disabled={isExporting}
      >
        {isExporting ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Download className="h-4 w-4" />
        )}
        Exportar
      </Button>
    </div>
  );
};
